/**
 * Set viewport height/width based on actual width/height rather than including
 * scrollbar, mobile address bar, bottom page controls, etc.
 * Combined with _viewport.scsss
 *
 * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 */

const calculateViewportHeight = () => {
	// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
	const vh = window.innerHeight * 0.01;
	// Then we set the value in the --vh custom property to the root of the document
	document.documentElement.style.setProperty('--vh', `${vh}px`);
};

const calculateViewportWidth = () => {
	// First we get the viewport width and we multiple it by 1% to get a value for a vw unit
	// for width we purposefully use document.body since window.innerWidth also counts scrollbar
	const vw = document.body.clientWidth * 0.01;
	// Then we set the value in the --vw custom property to the root of the document
	document.documentElement.style.setProperty('--vw', `${vw}px`);
};

const init = () => {
	calculateViewportHeight();
	calculateViewportWidth();
};

module.exports = {
	init,
	onResize: init
};
